__turbopack_context__.v({
  "carousel": "SocialHomeBlock-module__pEsxHG__carousel",
  "container": "SocialHomeBlock-module__pEsxHG__container",
  "grid": "SocialHomeBlock-module__pEsxHG__grid",
  "hidden": "SocialHomeBlock-module__pEsxHG__hidden",
  "nextButton": "SocialHomeBlock-module__pEsxHG__nextButton",
  "root": "SocialHomeBlock-module__pEsxHG__root",
  "scrollArea": "SocialHomeBlock-module__pEsxHG__scrollArea",
});
